import classNames from 'classnames';

import style from './divider.module.css';

type DividerVariant = 'default' | 'gradient';
type DividerThickness = 1 | 2 | 4;

interface DividerProps {
  thickness?: DividerThickness;
  variant?: DividerVariant;
}

const thicknessMap: Record<DividerThickness, string> = {
  [1]: style.dividerThickness1,
  [2]: style.dividerThickness2,
  [4]: style.dividerThickness4,
};

const variantMap: Record<DividerVariant, string> = {
  default: style.dividerDefault,
  gradient: style.dividerGradient,
};

const Divider = ({
  thickness = 1,
  variant = 'default',
}: DividerProps) => {
  return (
    <hr
      className={classNames(
        style.divider,
        thicknessMap[thickness],
        variantMap[variant],
      )}
    />
  );
};

export default Divider;
